import { z } from 'zod'

// ── Leaf schemas ───────────────────────────────────────────────────────────────

export const forecastTopPendingSchema = z.object({
  employee_name: z.string(),
  leave_id: z.guid(),
  start_date: z.string(),
  end_date: z.string(),
  days: z.number().int(),
})

export type ForecastTopPending = z.infer<typeof forecastTopPendingSchema>

// ── Team slice ─────────────────────────────────────────────────────────────────

export const forecastTeamSliceSchema = z.object({
  team_id: z.guid(),
  team_name: z.string(),
  days_at_or_below_min: z.number().int(),
  breach_dates: z.array(z.string()),
  pending_count: z.number().int(),
  top_pending: z.array(forecastTopPendingSchema),
})

export type ForecastTeamSlice = z.infer<typeof forecastTeamSliceSchema>

// ── Digest payload ─────────────────────────────────────────────────────────────

export const forecastDigestPayloadSchema = z.object({
  hod_id: z.guid(),
  hod_name: z.string(),
  generated_at: z.string(),
  window_start: z.string(),
  window_end: z.string(),
  total_breach_days: z.number().int(),
  teams: z.array(forecastTeamSliceSchema),
  rendered_sql: z.string().nullable(),
})

export type ForecastDigestPayload = z.infer<typeof forecastDigestPayloadSchema>
